<template>
  <transition
    enter-active-class="ease-out duration-300"
    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
    leave-active-class="ease-in duration-200"
    leave-class="opacity-100 translate-y-0 sm:scale-100"
    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  >
    <ontick-modal :open="active" v-on:close="$emit('close')" size="small">
      <div>
        <h1
          class="mb-6 text-center text-2xl font-bold text-ontick-steel-900 dark:text-gray-300"
        >
          {{ title }}
        </h1>

        <div class="flex justify-center space-x-2 pb-6">
          <div
            class="h-6 w-6"
            v-html="itemLogo(selectedAccount.broker_name)"
          ></div>
          <p
            class="text-lg font-semibold text-ontick-steel-900 dark:text-gray-200"
          >
            {{ selectedAccount.broker_name }}
          </p>
          <p class="text-lg font-medium text-gray-400">
            (#{{ selectedAccount.account_number }})
          </p>

          <!-- <p
            :class="
              selectedAccount.account_type == 'DEMO'
                ? 'bg-gray-500 text-gray-200'
                : 'bg-ontick-blue-900 text-ontick-blue-500'
            "
            class="flex items-center rounded-md px-2 py-0.5 text-sm font-medium"
          >
            {{ selectedAccount.account_type }}
          </p> -->
          <ontick-account-type-badge-component
            :accountType="selectedAccount.account_type"
          />
        </div>
        <ontick-text class="flex justify-center" align="left">
          <div
            class="mx-auto w-11/12 text-ontick-carbon-900 dark:text-ontick-graphite-300 sm:w-5/6 md:w-4/6"
          >
            <p class="flex">
              <span
                class="pr-2 text-ontick-green-500"
                v-html="$icons.check"
              ></span>
              Todas as posições abertas serão fechadas.
            </p>
            <p class="flex">
              <span
                class="pr-2 text-ontick-green-500"
                v-html="$icons.check"
              ></span>
              Todas as ordens pendentes serão canceladas.
            </p>
            <p class="flex">
              <span
                class="pr-2 text-ontick-green-500"
                v-html="$icons.check"
              ></span>
              Todos os investimentos nesta conta serão finalizados.
            </p>
            <!--            <p class="flex">
              <span
                class="pr-2 text-ontick-green-500"
                v-html="$icons.check"
              ></span>
              Não será mais possivel inicializar os investimentos no dia
              corrente.
            </p>-->
          </div>
        </ontick-text>

        <div v-if="selectedAccount.account_type == 'PRD'" class="mt-6 mb-6">
          <ontick-text align="center"
            >Digite "<span class="font-medium italic text-ontick-blue-500"
              >confirmar</span
            >" abaixo para parar o investimento</ontick-text
          >
          <div class="mx-auto mt-4 w-9/12">
            <input
              type="text"
              v-model="confirmationText"
              @keyup="keyupConfirmationText($event)"
              class="input_form focus:outline-none block w-full appearance-none rounded-md bg-ontick-steel-100 px-4 py-3 text-ontick-steel-900 focus:border-ontick-red-500 dark:bg-ontick-carbon-500 dark:text-gray-200 sm:text-sm"
              placeholder='Digite "confirmar"'
              maxlength="9"
              ref="inputConfirmationText"
            />
          </div>
        </div>
        <div
          :class="[
            ['DEMO', 'CONTEST'].includes(selectedAccount.account_type)
              ? 'mt-6'
              : 'mt-0',
          ]"
          class="mb-3 flex justify-center text-center"
        >
          <!-- Demo -->
          <button
            type="button"
            v-if="['DEMO', 'CONTEST'].includes(selectedAccount.account_type)"
            @click="clickConfirmation"
            class="focus:outline-none w-4/6 items-center justify-center rounded-md bg-ontick-red-700 px-6 py-3 font-semibold uppercase leading-5 text-gray-300 hover:bg-ontick-red-800"
          >
            Confirmar
          </button>
          <!-- /end Demo -->

          <!-- Production -->
          <button
            type="button"
            v-else-if="selectedAccount.account_type == 'PRD'"
            @click="clickConfirmation"
            :class="[
              buttonDisabled
                ? 'cursor-not-allowed bg-ontick-steel-500'
                : 'bg-ontick-red-700 hover:bg-ontick-red-800',
              'focus:outline-none w-4/6 items-center justify-center rounded-md px-6 py-3 font-semibold uppercase  leading-5 text-gray-300',
            ]"
          >
            Confirmar
          </button>
          <!-- /end Production -->
        </div>
      </div>
    </ontick-modal>
  </transition>
</template>
<script>
import { mapActions, mapState } from "vuex";
import OntickAccountTypeBadgeComponent from "../../../../../shared/components/basic/ontick-account-type-badge.component.vue";

export default {
  name: "modal-stop-all",
  components: {
    // PincodeInput,
    OntickAccountTypeBadgeComponent,
  },
  props: {
    active: { type: Boolean, default: false },
  },
  data() {
    return {
      confirmationText: "",
      buttonDisabled: true,
      code: "",
      title: "Parar tudo",
      description: ` <br> Todos os investimentos nesta conta serão finalizados. <br> Não será mais possivel inicializar os investimentos no dia corrente.`,
      styles: {
        button:
          "font-bold text-ontick-light uppercase bg-ontick-third inline-flex items-center px-6 py-3 rounded",
        buttonSpan:
          "w-full text-center text-ontick-small text-ontick-white uppercase font-bold",
      },
    };
  },
  computed: {
    activeModal() {
      return this.active;
    },
    ...mapState({
      selectedAccount: (state) => state.accountTypes.selectedAccount,
    }),
  },
  created() {
    this.$nextTick(() => {
      if (this.selectedAccount.account_type == "PRD")
        this.$refs.inputConfirmationText.focus();
    });
  },
  methods: {
    itemLogo(value) {
      let img;
      if (value == "OnTick") {
        img = this.$icons.ontick;
      } else if (value == "XP") {
        img = this.$icons.xp;
      } else if (value == "Cripto") {
        img = this.$icons.bitcoin;
      }
      return img;
    },
    keyupConfirmationText(event) {
      var key = event.which || event.keyCode;
      if (key == 13) {
        this.clickConfirmation();
      }
      this.confirmationText = event.target.value
        .replace(/[^\w\s]/gi, "")
        .replace(/\d+/g, "")
        .toLowerCase();
      if (event.target.value == "confirmar") {
        this.buttonDisabled = false;
      } else {
        this.buttonDisabled = true;
      }
    },
    clickConfirmation() {
      if (["DEMO", "CONTEST"].includes(this.selectedAccount.account_type)) {
        this.$emit("stopAll", this.selectedAccount.account_id);
      }
      if (!this.buttonDisabled) {
        this.$emit("stopAll", this.selectedAccount.account_id);
      }
    },
  },
};
</script>

<style lang="scss">
// PINCODE COMPONENT
div.vue-pincode-input-wrapper {
  // any styles you want for wrapper
  background-color: #202a37 !important;
  display: flex;
  justify-content: center;
}

input.vue-pincode-input {
  // any styles you want for each cell
  background-color: #171e27 !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
  color: white !important;
  font-size: 40px !important;
  font-weight: 600 !important;
  padding: 6px 12px !important;
  max-width: 75px;
  margin: 12px;
  border: 2px solid #171e27;
  transition: all 0.3s ease;
  &:focus {
    border: 2px solid #07a4ff;
  }
}

@media screen and (max-width: 600px) {
  input.vue-pincode-input {
    // any styles you want for each cell
    background-color: #171e27 !important;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
    color: white !important;
    font-size: 35px !important;
    font-weight: 600 !important;
    padding: 6px 6px !important;
    max-width: 50px;
    margin: 6px;
    border: 2px solid #171e27;
    transition: all 0.3s ease;
    &:focus {
      border: 2px solid #07a4ff;
    }
  }
}
</style>
